import React from "react";
import FloatingField from "./FloatingField";
import Select from "components/CarProduct/component/Select";

export default function CarOwnerInfoSection({
  form,
  updateField,
  setFieldTouched,
  onToggleIsOwner,
  // Errors
  carOwnerError,
  licensePlatesError,
  carBrandError,
  carModelError,
  chassisNoError,
  engineNoError,
  buyerNameError,
  buyerPhoneError,
  emailError,
  addressError,
  // Invoice Errors
  invoiceCompanyNameError,
  invoiceTaxCodeError,
  invoiceCompanyAddressError,
  invoicePhoneError,
  invoiceEmailError,
  invoiceRecipientNameError,
  invoiceProvinceError,
  // Data options
  carBrands,
  carModels,
  provinces,
  // Loadings
  loadingBrands,
  loadingModels,
  // Event handlers for cascading selects
  handleBrandChange,
  handleModelChange,
}) {
  return (
    <div className="car-insurance__owner-section">
      <h2 className="car-insurance__section-title car-insurance__section-title--spaced">
        Thông tin xe &amp; Chủ sở hữu
      </h2>

      {/* 1. Họ tên chủ xe */}
      <FloatingField
        id="car-owner-name"
        label="Họ và tên chủ xe *"
        placeholder="NHẬP HỌ TÊN IN HOA (VD: NGUYỄN VĂN A)"
        error={carOwnerError}
        value={form.carOwner}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, carOwner: true }))}
        onChange={(e) => {
          const val = e.target.value;
          updateField("carOwner", val);
        }}
      />

      {/* 2. Biển số xe */}
      <FloatingField
        id="car-license-plates"
        label="Biển số xe *"
        placeholder="VD: 30A12345 hoặc 51F99999"
        error={licensePlatesError}
        value={form.licensePlates}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, licensePlates: true }))}
        onChange={(e) => updateField("licensePlates", e.target.value.toUpperCase())}
      />

      {/* 3. Hãng xe (Select) */}
      <div className="car-insurance__input-box-wrap">
        <Select
          title={"Chọn Hãng xe"}
          placeholder={"Chọn Hãng xe *"}
          error={carBrandError}
          selectedValue={form.carBrand || {}}
          data={carBrands || []}
          onValueChange={(val) => {
            handleBrandChange(val);
            setFieldTouched((prev) => ({ ...prev, carBrand: true }));
          }}
          isLoading={loadingBrands}
          require
          heightModal="50vh"
          isHideRequired
        />
        {carBrandError ? (
          <div className="car-insurance__error">{carBrandError}</div>
        ) : null}
      </div>

      {/* 4. Hiệu xe (Select) */}
      <div className="car-insurance__input-box-wrap">
        <Select
          title={"Chọn Hiệu xe"}
          placeholder={"Chọn Hiệu xe *"}
          error={carModelError}
          selectedValue={form.carModel || {}}
          data={carModels || []}
          disabled={!form.carBrand?.code}
          onValueChange={(val) => {
            handleModelChange(val);
            setFieldTouched((prev) => ({ ...prev, carModel: true }));
          }}
          isLoading={loadingModels}
          require
          heightModal="50vh"
          isHideRequired
        />
        {carModelError ? (
          <div className="car-insurance__error">{carModelError}</div>
        ) : null}
      </div>

      {/* 5. Số khung */}
      <FloatingField
        id="car-chassis-no"
        label="Số khung *"
        placeholder="Nhập số khung theo Đăng ký xe"
        error={chassisNoError}
        value={form.chassisNo}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, chassisNo: true }))}
        onChange={(e) => updateField("chassisNo", e.target.value)}
      />

      {/* 6. Số máy */}
      <FloatingField
        id="car-engine-no"
        label="Số máy *"
        placeholder="Nhập số máy theo Đăng ký xe"
        error={engineNoError}
        value={form.engineNo}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, engineNo: true }))}
        onChange={(e) => updateField("engineNo", e.target.value)}
      />

      {/* SECTION: THÔNG TIN NGƯỜI MUA BẢO HIỂM */}
      <h2 className="car-insurance__section-title car-insurance__section-title--spaced">
        Thông tin người mua bảo hiểm
      </h2>

      {/* Checkbox: Người mua bảo hiểm là chủ xe */}
      <div className="car-insurance__buyer-checkbox-row">
        <label className="car-insurance__checkbox-container" htmlFor="car-is-owner-toggle">
          <input
            id="car-is-owner-toggle"
            type="checkbox"
            className="car-insurance__checkbox-input"
            checked={!!form.isOwner}
            onChange={(e) => {
              const checked = e.target.checked;
              if (onToggleIsOwner) {
                onToggleIsOwner(checked);
              } else {
                updateField("isOwner", checked);
              }
            }}
          />
          <span className="car-insurance__checkbox-custom">
            {form.isOwner ? <span className="car-insurance__checkbox-icon">✓</span> : null}
          </span>
          <span className="car-insurance__checkbox-text">Người mua bảo hiểm là chủ xe</span>
        </label>
      </div>

      {/* 7. Họ tên người mua */}
      <FloatingField
        id="car-buyer-name"
        label="Họ và tên người mua *"
        placeholder="Nhập họ và tên bên mua bảo hiểm"
        error={buyerNameError}
        value={form.buyerName}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, buyerName: true }))}
        onChange={(e) => updateField("buyerName", e.target.value)}
      />

      {/* 8. Số điện thoại */}
      <FloatingField
        id="car-buyer-phone"
        label="Số điện thoại người mua *"
        placeholder="VD: 0912345678"
        error={buyerPhoneError}
        value={form.buyerPhone}
        inputMode="tel"
        autoComplete="tel"
        onBlur={() => setFieldTouched((prev) => ({ ...prev, buyerPhone: true }))}
        onChange={(e) => updateField("buyerPhone", e.target.value)}
      />

      {/* 9. Email */}
      <FloatingField
        id="car-buyer-email"
        label="Email nhận Giấy chứng nhận (không bắt buộc)"
        placeholder="VD: example@email.com"
        error={emailError}
        value={form.email}
        inputMode="email"
        autoComplete="email"
        onBlur={() => setFieldTouched((prev) => ({ ...prev, email: true }))}
        onChange={(e) => updateField("email", e.target.value)}
      />

      {/* 10. Địa chỉ chi tiết */}
      <FloatingField
        id="car-buyer-address"
        label="Số nhà, tên đường *"
        placeholder="Nhập số nhà, tên đường..."
        error={addressError}
        value={form.address}
        onBlur={() => setFieldTouched((prev) => ({ ...prev, address: true }))}
        onChange={(e) => updateField("address", e.target.value)}
      />

      {/* SECTION: THÔNG TIN XUẤT HÓA ĐƠN */}
      <div className="car-insurance__invoice-checkbox-row">
        <label className="car-insurance__checkbox-container" htmlFor="car-invoice-toggle">
          <input
            id="car-invoice-toggle"
            type="checkbox"
            className="car-insurance__checkbox-input"
            checked={!!form.hasInvoice}
            onChange={(e) => updateField("hasInvoice", e.target.checked)}
          />
          <span className="car-insurance__checkbox-custom">
            {form.hasInvoice ? <span className="car-insurance__checkbox-icon">✓</span> : null}
          </span>
          <span className="car-insurance__checkbox-text">Thông tin xuất hóa đơn</span>
        </label>
      </div>

      {form.hasInvoice ? (
        <div className="car-insurance__invoice-form-card">
          <h3 className="car-insurance__invoice-title">Thông tin xuất hóa đơn VAT</h3>

          {/* 1. Tên công ty */}
          <FloatingField
            id="invoice-company-name"
            label="Tên công ty *"
            placeholder="Nhập tên công ty xuất hóa đơn"
            error={invoiceCompanyNameError}
            value={form.invoiceCompanyName}
            onBlur={() => setFieldTouched((prev) => ({ ...prev, invoiceCompanyName: true }))}
            onChange={(e) => updateField("invoiceCompanyName", e.target.value)}
          />

          {/* 2. Mã số thuế */}
          <FloatingField
            id="invoice-tax-code"
            label="Mã số thuế *"
            placeholder="Nhập mã số thuế công ty"
            error={invoiceTaxCodeError}
            value={form.invoiceTaxCode}
            onBlur={() => setFieldTouched((prev) => ({ ...prev, invoiceTaxCode: true }))}
            onChange={(e) => updateField("invoiceTaxCode", e.target.value)}
          />

          {/* 3. Địa chỉ công ty */}
          <FloatingField
            id="invoice-company-address"
            label="Địa chỉ công ty *"
            placeholder="Nhập địa chỉ công ty"
            error={invoiceCompanyAddressError}
            value={form.invoiceCompanyAddress}
            onBlur={() => setFieldTouched((prev) => ({ ...prev, invoiceCompanyAddress: true }))}
            onChange={(e) => updateField("invoiceCompanyAddress", e.target.value)}
          />

          {/* 4. Số điện thoại */}
          <FloatingField
            id="invoice-phone"
            label="Số điện thoại *"
            placeholder="VD: 0912345678"
            error={invoicePhoneError}
            value={form.invoicePhone}
            inputMode="tel"
            autoComplete="tel"
            onBlur={() => setFieldTouched((prev) => ({ ...prev, invoicePhone: true }))}
            onChange={(e) => updateField("invoicePhone", e.target.value)}
          />

          {/* 5. Email nhận hóa đơn điện tử */}
          <FloatingField
            id="invoice-email"
            label="Email nhận hóa đơn điện tử *"
            placeholder="VD: hoadon@company.com"
            error={invoiceEmailError}
            value={form.invoiceEmail}
            inputMode="email"
            autoComplete="email"
            onBlur={() => setFieldTouched((prev) => ({ ...prev, invoiceEmail: true }))}
            onChange={(e) => updateField("invoiceEmail", e.target.value)}
          />

          {/* 6. Tên người nhận */}
          <FloatingField
            id="invoice-recipient-name"
            label="Tên người nhận *"
            placeholder="Nhập tên người nhận hóa đơn"
            error={invoiceRecipientNameError}
            value={form.invoiceRecipientName}
            onBlur={() => setFieldTouched((prev) => ({ ...prev, invoiceRecipientName: true }))}
            onChange={(e) => updateField("invoiceRecipientName", e.target.value)}
          />

          {/* 7. Tỉnh thành */}
          <div className="car-insurance__input-box-wrap">
            <Select
              title="Chọn Tỉnh thành"
              placeholder="Chọn Tỉnh thành *"
              error={invoiceProvinceError}
              selectedValue={form.invoiceProvince || {}}
              data={provinces || []}
              onValueChange={(val) => {
                updateField("invoiceProvince", val);
                setFieldTouched((prev) => ({ ...prev, invoiceProvince: true }));
              }}
              require
              heightModal="50vh"
              isHideRequired
            />
            {invoiceProvinceError ? (
              <div className="car-insurance__error">{invoiceProvinceError}</div>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}

